import { Users, CalendarDays, Circle, MoreVertical } from 'lucide-react';

export interface Committee {
  id: number;
  name: string;
  type: string;
  schedule: string;
  role: string;
  members: number;
  cadence: string;
  status: string;
}

interface Props {
  committee: Committee;
}

const CommitteeRow = ({ committee }: Props) => {
  return (
    <div className="committee-row">
      {/* Committee Name */}
      <div className="committee-name-cell">
        <div className="committee-name-icon">
          <Users size={14} className="text-[#14B8A6]" />
        </div>

        <span className="committee-name-text">{committee.name}</span>
      </div>

      {/* Committee Type */}
      <div className="committee-body-text">{committee.type}</div>

      {/* Schedule */}
      <div className="flex items-center gap-2 committee-body-text">
        <CalendarDays size={14} className="text-[#6B7280]" />
        {committee.schedule}
      </div>

      {/* Role */}
      <div className="flex items-center gap-2 committee-body-text">
        <Circle size={8} />
        {committee.role}
      </div>

      {/* Members */}
      <div className="flex items-center gap-2 committee-body-text">
        <Users size={14} />
        {committee.members}
      </div>

      {/* Cadence */}
      <div className="text-[12px] font-medium text-[#0EA5A5]">{committee.cadence}</div>

      {/* Status */}
      <div>
        <span className="px-3 py-1 rounded-full bg-green-100 text-green-700 text-xs font-medium">{committee.status}</span>
      </div>

      {/* Action */}
      <button className="justify-self-end">
        <MoreVertical size={16} className="text-[#6B7280]" />
      </button>
    </div>
  );
};

export default CommitteeRow;
